<template>
    <div class="m-rule">
        <h5 class="title"></h5>

        <div class="page-view">
            <div class="rule-panel">
                <div class="rule-text">
                    <div class="rule-item" v-for="(item,index) in rule_text" :key="index">
                        <span class="tag">{{ item.tag }}</span>
                        <span>{{ item.content }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
h5.title{
    width: 708px;
    height: 185px;
    margin: 0 auto 28px;
    background-image: url(~@/assets/images/pc/title-6.png);
}

.rule-panel{
    width: 940px;
    margin: -40px auto 0;
    padding-top: 10px;
    box-sizing: border-box;
}

.rule-text{
    margin:  0 auto;
    font-size: 16px;
    color: #e7dfad;
}

.rule-item{
    position: relative;
    line-height: 1.6;
    margin-bottom: 20px;
    padding-left: 40px;
}

.rule-text .tag{
    position: absolute;
    left: 0;
    top: 2px;
    display: inline-block;
    width: 24px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 24px;
    color: #03838f;
    font-weight: 700;
    background-image: url(~@/assets/images/pc/rule-tab.png);
}
</style>

<script>
export default {
    data (){
        return {
            rule_text : [
                {
                    tag : '1',
                    content : '【招募说明】被邀请的回归玩家，需登录游戏在招募请求界面确认，即为邀请成功。如果出现回归好友显示未登录的情况，请好友重新登录网页更新状态',
                },
                {
                    tag : '2',
                    content : '【招募数量】一个招募者可邀请4名回归玩家来完成任务，一个回归玩家同时只能被一个招募者招募',
                },
                {
                    tag : '3',
                    content : '【回归条件】被招募时的等级需≥11级，历史充值达到要求，且截止至2023年12月14日超过30天未登录游戏可成为回归玩家',
                },
                {
                    tag : '4',
                    content : '【积分获取】非回归招募者需任意一位回归玩家被招募后完成任务；回归玩家可自己或招募其他回归玩家完成任务。（所有身份玩家每个奖励只可领取一次，未绑定的回归玩家也可单独完成任务）',
                },
                {
                    tag : '5',
                    content : '【竞技/出征地图】娱乐*三国无双、官渡*经典之战、三国志大战、英霸官渡、天命无双、官渡*天命无双、英霸*天命无双、天命*荆州争霸、军团出征、军团出征巅峰场，仙术师只能通过匹配模式完成任务（中退局、约战不计入）',
                }, 
                {
                    tag : '6',
                    content : '【招募限制】招募者等级≥11，正式区、wegame区、steam区、测试区的玩家不可跨大区招募',
                }, 
                {
                    tag : '7',
                    content : '【分享助力】同一个电魂ID可帮人助力3次',
                }, 
                {
                    tag : '8',
                    content : '【活动时间】2023年12月14日-2024年1月17日',
                },                                                                                                
            ],
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/view/rule.vue